import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal from "../components/Reveal";
import BlurImage from "../components/BlurImage";
import api from "../lib/api";

export default function Blog() {
    const [posts, setPosts] = useState([]);
    useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)).catch(() => {}); }, []);
    const [feature, ...rest] = posts;

    return (
        <div data-testid="blog-page">
            <section className="bg-offwhite py-20 lg:py-24 border-b border-neutral-200">
                <div className="mx-container text-center">
                    <p className="overline mb-5">Journal</p>
                    <h1 className="font-display font-black uppercase tracking-tightest text-5xl sm:text-7xl leading-[0.9] max-w-4xl mx-auto">Notes on the <span className="text-brand-blue">craft & business.</span></h1>
                </div>
            </section>

            <section className="py-16 lg:py-24 bg-white">
                <div className="mx-container">
                    {feature && (
                        <Reveal>
                            <Link to={`/blog/${feature.slug}`} className="group grid lg:grid-cols-2 gap-8 lg:gap-12 items-center mb-16 pb-16 border-b border-neutral-200" data-testid={`blog-feature-${feature.slug}`}>
                                <div className="relative overflow-hidden aspect-[16/10]">
                                    <BlurImage src={feature.cover} alt={feature.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                                </div>
                                <div className="text-center lg:text-left">
                                    <p className="overline mb-3">{feature.category} · {feature.read_time}</p>
                                    <h2 className="font-display font-black uppercase tracking-tightest text-3xl sm:text-4xl leading-tight group-hover:text-brand-blue transition-colors">{feature.title}</h2>
                                    <p className="mt-4 text-neutral-500 leading-relaxed max-w-lg mx-auto lg:mx-0">{feature.excerpt}</p>
                                    <span className="mt-6 inline-flex items-center gap-1.5 link-blue uppercase text-sm tracking-wide">Read article <ArrowUpRight className="h-4 w-4" /></span>
                                </div>
                            </Link>
                        </Reveal>
                    )}
                    <div className="grid md:grid-cols-3 gap-x-6 gap-y-12">
                        {rest.map((p, i) => (
                            <Reveal key={p.slug} delay={(i % 3) * 0.06}>
                                <Link to={`/blog/${p.slug}`} className="group block text-center" data-testid={`blog-card-${p.slug}`}>
                                    <div className="relative overflow-hidden aspect-[16/10]">
                                        <BlurImage src={p.cover} alt={p.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                                    </div>
                                    <p className="overline mt-4 mb-2">{p.category} · {p.read_time}</p>
                                    <h3 className="font-display font-bold text-xl leading-tight group-hover:text-brand-blue transition-colors">{p.title}</h3>
                                    <p className="mt-2 text-sm text-neutral-500 line-clamp-2">{p.excerpt}</p>
                                </Link>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
}
